import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Login } from './components/Login';
import { Chat } from './components/Chat';
import { ModalInstall } from './components/ModalInstall';
import PrivateRoute from './components/PrivateRoute';
import {
  toggleWidget
} from 'react-chat-widget';
import './App.css';


function App() {
  const isAuthenticated = () => {
    return !!localStorage.getItem('backend_password');
  };

  useEffect(() => {
    toggleWidget();
  }, []);

  return (
    <>
      <ModalInstall />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/chat" element={<PrivateRoute element={Chat} />} />
          <Route path="*" element={isAuthenticated() ? <Navigate to="/chat" replace /> : <Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
